module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/afoot57-29f7c4a8fa14c216345daabb3ef950ca.jpg";